import Swiper from 'swiper'
import { Navigation, Thumbs, Pagination } from 'swiper/modules';
import lightGallery from 'lightgallery';

class Gallery {
    constructor(element) {
        this.wrapper = element
        this.slider = this.wrapper.querySelector('.swiper')
        this.sliderWrapper = this.slider.querySelector('.swiper-wrapper')

        this.thumbsWrapper = document.querySelector('.gallery-slider-thumbnails')
        this.thumbsSlider = this.thumbsWrapper.querySelector('.swiper')

        this.swiper
        this.thumbs
        this.init()
    }

    init() {
        this.gallery(this)
    }

    gallery(root) {
        this.thumbs = new Swiper(this.thumbsSlider, {
            loop: true,
            spaceBetween: 17,
            initialSlide: 0,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesProgress: true,
        })

        this.swiper = new Swiper(this.slider, {
            modules: [ Navigation, Thumbs, Pagination ],
            slidesPerView: 1,
            initialSlide: 0,
            speed: 500,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
            },
            on: {
                init: function () {
                    const lg = lightGallery(root.sliderWrapper, {
                        licenseKey: 'purchase-in-progress',
                        animateThumb: false,
                        zoomFromOrigin: false,
                        allowMediaOverlap: true,
                        toggleThumb: true,
                        download: false,
                    })
                }
            },
            thumbs: {
                swiper: this.thumbs,
            }
        })
    }
}

const gallerySliders = document.querySelectorAll('.gallery-slider')

gallerySliders.forEach(slider => {
    new Gallery(slider)
})
